<li class="flex justify-between gap-x-6 py-5 card-container-pale">
    <div class="shrink-0 flex flex-row items-center min-w-0 gap-x-4">


        <div
            [class]="'size-16 rounded-md flex flex-col items-center justify-center ' + getPercentageClasses().background">
            <p [class]="'text-sm/6 font-semibold ' + getPercentageClasses().text">
                {{ getSuccessPercentage() }}%
            </p>
        </div>

        <div class="min-w-0 flex-auto items-center">
            <p class="text-sm font-semibold text-primary">
                {{ creator.name }}
            </p>
            <div class="mt-1 flex flex-row w-full items-center gap-x-4">
                @if (creator.tiktokHandle) {
                <div class="flex items-center gap-1">
                    <img class="h-3 w-3" src="../../../../../assets/social-icon/tik-tok-transparent.svg" alt="TikTok">
                    <p class="text-sm text-primary">
                        {{ creator.tiktokHandle }}
                    </p>
                </div>
                }
                @if (creator.instagramHandle) {
                <div class="flex items-center gap-1">
                    <img class="h-3 w-3" src="../../../../../assets/social-icon/instagram-logo.png" alt="TikTok">
                    <p class="text-sm text-primary">
                        {{ creator.instagramHandle }}
                    </p>
                </div>
                }
            </div>
        </div>
    </div>



    <div class="flex shrink-0 items-center gap-x-4">

        <div class="flex flex-row items-center justify-center gap-x-2">
            <span
                class="inline-flex items-center rounded-full bg-blue-400/10 px-2 py-1 text-xs font-medium text-blue-400 inset-ring inset-ring-blue-400/30">Reviewed:
                <b class="ml-1 text-sm font-semibold">{{ totalReviewedCount() }}</b>
            </span>
            <span
                class="inline-flex items-center rounded-full bg-red-400/10 px-2 py-1 text-xs font-medium text-red-400 inset-ring inset-ring-red-400/30">Issues:
                <b class="ml-1 text-sm font-semibold">{{ issuesFound() }}</b>
            </span>

        </div>

        <div class="flex flex-row items-center justify-center gap-x-2">
            <button type="button" [appTooltip]="'Collaborate'" position="left"
                class="fab-button-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="M16 5H3" />
                    <path d="M11 12H3" />
                    <path d="M16 19H3" />
                    <path d="M18 9v6" />
                    <path d="M21 12h-6" />
                </svg>
            </button>


            <button type="button" (click)="navigateToReport()"
                [appTooltip]="'View Report'" position="left" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m9 18 6-6-6-6" />
                </svg>
            </button>
        </div>

    </div>
</li>